/* PhenAprin CRO PDP behavior: gallery switcher, bundle selector, sticky ATC bar.
   Dependency-free, deferred. Scoped to .pdp-cro markup produced by sections/pdp-cro.liquid. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  ready(function () {
    var root = document.querySelector('.pdp-cro');
    if (!root) return;

    /* ---- Gallery: thumbnail click swaps the active main slide ---- */
    var thumbs = root.querySelectorAll('.pdp-cro__thumb');
    var slides = root.querySelectorAll('.pdp-cro__gallery-slide');
    if (thumbs.length && slides.length) {
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var idx = thumb.getAttribute('data-index');
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          slides.forEach(function (s) { s.classList.remove('is-active'); });
          thumb.classList.add('is-active');
          var target = root.querySelector('.pdp-cro__gallery-slide[data-index="' + idx + '"]');
          if (target) target.classList.add('is-active');
        });
      });
    }

    /* ---- Bundle / quantity selector: updates the hidden quantity input ---- */
    var bundleOpts = root.querySelectorAll('.pdp-cro__bundle-opt');
    var qtyInputs = root.querySelectorAll('input[data-pdp-cro-qty]');
    if (bundleOpts.length) {
      bundleOpts.forEach(function (opt) {
        opt.addEventListener('click', function () {
          bundleOpts.forEach(function (o) {
            o.classList.remove('is-active');
            o.setAttribute('aria-checked', 'false');
          });
          opt.classList.add('is-active');
          opt.setAttribute('aria-checked', 'true');
          var qty = opt.getAttribute('data-qty') || '1';
          qtyInputs.forEach(function (input) { input.value = qty; });
        });
        opt.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            opt.click();
          }
        });
      });
    }

    /* ---- Sticky add-to-cart bar: show when the main buy box scrolls out ---- */
    var bar = document.querySelector('.pdp-cro-stickybar');
    var sentinel = root.querySelector('[data-pdp-cro-atc-anchor]');
    if (bar && sentinel && 'IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            bar.classList.remove('is-visible');
          } else if (entry.boundingClientRect.top < 0) {
            bar.classList.add('is-visible');
          }
        });
      }, { threshold: 0, rootMargin: '0px 0px 0px 0px' });
      obs.observe(sentinel);
    }

    /* ---- Sticky bar CTA: scroll to the buy box (form submit handled natively) ---- */
    var barCta = bar ? bar.querySelector('[data-pdp-cro-sticky-cta]') : null;
    if (barCta && barCta.tagName === 'BUTTON') {
      barCta.addEventListener('click', function () {
        var form = root.querySelector('[data-pdp-cro-form] form, form[data-pdp-cro-form]');
        var submit = root.querySelector('[data-pdp-cro-atc]');
        if (submit) {
          submit.click();
        } else if (form && form.requestSubmit) {
          form.requestSubmit();
        }
      });
    }

    /* ---- Supplement Facts panel: click to enlarge (dependency-free lightbox) ---- */
    var factsImg = root.querySelector('.pdp-cro__factspanel .pdp-cro__media-img');
    if (factsImg) {
      var box = null;
      var lastFocus = null;

      function closeBox() {
        if (!box) return;
        document.removeEventListener('keydown', onKeydown);
        document.body.classList.remove('pdp-cro-lightbox-open');
        if (box.parentNode) box.parentNode.removeChild(box);
        box = null;
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }

      function onKeydown(e) {
        if (e.key === 'Escape' || e.key === 'Esc') {
          e.preventDefault();
          closeBox();
        }
      }

      function openBox() {
        if (box) return;
        lastFocus = document.activeElement;

        box = document.createElement('div');
        box.className = 'pdp-cro__lightbox';
        box.setAttribute('role', 'dialog');
        box.setAttribute('aria-modal', 'true');
        box.setAttribute('aria-label', factsImg.alt || 'Supplement Facts panel, enlarged');

        var big = document.createElement('img');
        big.className = 'pdp-cro__lightbox-img';
        big.src = factsImg.currentSrc || factsImg.src;
        big.alt = factsImg.alt || '';

        var close = document.createElement('button');
        close.className = 'pdp-cro__lightbox-close';
        close.type = 'button';
        close.setAttribute('aria-label', 'Close');
        close.innerHTML = '&times;';

        box.appendChild(big);
        box.appendChild(close);

        close.addEventListener('click', function (e) {
          e.stopPropagation();
          closeBox();
        });
        big.addEventListener('click', function (e) {
          e.stopPropagation();
        });
        box.addEventListener('click', closeBox);
        document.addEventListener('keydown', onKeydown);

        document.body.classList.add('pdp-cro-lightbox-open');
        document.body.appendChild(box);
        close.focus();
      }

      factsImg.setAttribute('role', 'button');
      factsImg.setAttribute('tabindex', '0');
      factsImg.addEventListener('click', openBox);
      factsImg.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          openBox();
        }
      });
    }
  });
})();